import { usePromotePageData } from 'src/app/pages/promote/pageContext';

export function useIsMembershipEligible(): boolean {
	const {
		data: {
			membershipProgram,
			user: { hasSubscription },
			featureConfigs: { membershipPPMUEnabled },
		},
	} = usePromotePageData();

	if (!membershipPPMUEnabled || !membershipProgram || hasSubscription) return false;

	return true;
}
